/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  LoginReq,
  LoginResp,
  LoginSmsReq,
  RefreshReq,
  RefreshResp,
  RegisterConfirmReq,
  RegisterReq,
  RegisterResp,
  SessionHandoffExchangeReq,
  SessionHandoffTicketResp,
  SetPasswordReq,
  VerifyPasswordReq,
  VerifyPasswordResp,
} from "./auth-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const Register = (
  registerReq?: RegisterReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<RegisterResp>(
    {
      url: `/intl/auth/register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerReq,
      signal,
    },
    options,
  );
};

export const getRegisterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Register>>,
    TError,
    { data?: RegisterReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Register>>,
  TError,
  { data?: RegisterReq },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Register>>,
    { data?: RegisterReq }
  > = (props) => {
    const { data } = props ?? {};

    return Register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof Register>>
>;
export type RegisterMutationBody = RegisterReq | undefined;
export type RegisterMutationError = unknown;

export const useRegister = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Register>>,
      TError,
      { data?: RegisterReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Register>>,
  TError,
  { data?: RegisterReq },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options), queryClient);
};
export const RegisterConfirm = (
  registerConfirmReq?: RegisterConfirmReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<RegisterResp>(
    {
      url: `/intl/auth/register-confirm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerConfirmReq,
      signal,
    },
    options,
  );
};

export const getRegisterConfirmMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof RegisterConfirm>>,
    TError,
    { data?: RegisterConfirmReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof RegisterConfirm>>,
  TError,
  { data?: RegisterConfirmReq },
  TContext
> => {
  const mutationKey = ["registerConfirm"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof RegisterConfirm>>,
    { data?: RegisterConfirmReq }
  > = (props) => {
    const { data } = props ?? {};

    return RegisterConfirm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof RegisterConfirm>>
>;
export type RegisterConfirmMutationBody = RegisterConfirmReq | undefined;
export type RegisterConfirmMutationError = unknown;

export const useRegisterConfirm = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof RegisterConfirm>>,
      TError,
      { data?: RegisterConfirmReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof RegisterConfirm>>,
  TError,
  { data?: RegisterConfirmReq },
  TContext
> => {
  return useMutation(getRegisterConfirmMutationOptions(options), queryClient);
};
export const Login = (
  loginReq?: LoginReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LoginResp>(
    {
      url: `/intl/auth/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loginReq,
      signal,
    },
    options,
  );
};

export const getLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Login>>,
    TError,
    { data?: LoginReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Login>>,
  TError,
  { data?: LoginReq },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Login>>,
    { data?: LoginReq }
  > = (props) => {
    const { data } = props ?? {};

    return Login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof Login>>
>;
export type LoginMutationBody = LoginReq | undefined;
export type LoginMutationError = unknown;

export const useLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Login>>,
      TError,
      { data?: LoginReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Login>>,
  TError,
  { data?: LoginReq },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options), queryClient);
};
export const CreateSessionHandoffTicket = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SessionHandoffTicketResp>(
    { url: `/intl/auth/session-handoff/ticket`, method: "POST", signal },
    options,
  );
};

export const getCreateSessionHandoffTicketMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof CreateSessionHandoffTicket>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof CreateSessionHandoffTicket>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["createSessionHandoffTicket"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof CreateSessionHandoffTicket>>,
    void
  > = () => {
    return CreateSessionHandoffTicket(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSessionHandoffTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof CreateSessionHandoffTicket>>
>;

export type CreateSessionHandoffTicketMutationError = unknown;

export const useCreateSessionHandoffTicket = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof CreateSessionHandoffTicket>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof CreateSessionHandoffTicket>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCreateSessionHandoffTicketMutationOptions(options),
    queryClient,
  );
};
export const ExchangeSessionHandoffTicket = (
  sessionHandoffExchangeReq?: SessionHandoffExchangeReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LoginResp>(
    {
      url: `/intl/auth/session-handoff/exchange`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sessionHandoffExchangeReq,
      signal,
    },
    options,
  );
};

export const getExchangeSessionHandoffTicketMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ExchangeSessionHandoffTicket>>,
    TError,
    { data?: SessionHandoffExchangeReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ExchangeSessionHandoffTicket>>,
  TError,
  { data?: SessionHandoffExchangeReq },
  TContext
> => {
  const mutationKey = ["exchangeSessionHandoffTicket"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ExchangeSessionHandoffTicket>>,
    { data?: SessionHandoffExchangeReq }
  > = (props) => {
    const { data } = props ?? {};

    return ExchangeSessionHandoffTicket(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExchangeSessionHandoffTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof ExchangeSessionHandoffTicket>>
>;
export type ExchangeSessionHandoffTicketMutationBody =
  SessionHandoffExchangeReq | undefined;
export type ExchangeSessionHandoffTicketMutationError = unknown;

export const useExchangeSessionHandoffTicket = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ExchangeSessionHandoffTicket>>,
      TError,
      { data?: SessionHandoffExchangeReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ExchangeSessionHandoffTicket>>,
  TError,
  { data?: SessionHandoffExchangeReq },
  TContext
> => {
  return useMutation(
    getExchangeSessionHandoffTicketMutationOptions(options),
    queryClient,
  );
};
export const LoginSms = (
  loginSmsReq?: LoginSmsReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<LoginResp>(
    {
      url: `/intl/auth/login-sms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loginSmsReq,
      signal,
    },
    options,
  );
};

export const getLoginSmsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof LoginSms>>,
    TError,
    { data?: LoginSmsReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof LoginSms>>,
  TError,
  { data?: LoginSmsReq },
  TContext
> => {
  const mutationKey = ["loginSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof LoginSms>>,
    { data?: LoginSmsReq }
  > = (props) => {
    const { data } = props ?? {};

    return LoginSms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof LoginSms>>
>;
export type LoginSmsMutationBody = LoginSmsReq | undefined;
export type LoginSmsMutationError = unknown;

export const useLoginSms = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof LoginSms>>,
      TError,
      { data?: LoginSmsReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof LoginSms>>,
  TError,
  { data?: LoginSmsReq },
  TContext
> => {
  return useMutation(getLoginSmsMutationOptions(options), queryClient);
};
export const Refresh = (
  refreshReq?: RefreshReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<RefreshResp>(
    {
      url: `/intl/auth/refresh`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: refreshReq,
      signal,
    },
    options,
  );
};

export const getRefreshMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Refresh>>,
    TError,
    { data?: RefreshReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Refresh>>,
  TError,
  { data?: RefreshReq },
  TContext
> => {
  const mutationKey = ["refresh"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Refresh>>,
    { data?: RefreshReq }
  > = (props) => {
    const { data } = props ?? {};

    return Refresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof Refresh>>
>;
export type RefreshMutationBody = RefreshReq | undefined;
export type RefreshMutationError = unknown;

export const useRefresh = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Refresh>>,
      TError,
      { data?: RefreshReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Refresh>>,
  TError,
  { data?: RefreshReq },
  TContext
> => {
  return useMutation(getRefreshMutationOptions(options), queryClient);
};
export const Logout = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/intl/auth/logout`, method: "POST", signal },
    options,
  );
};

export const getLogoutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Logout>>,
    void
  > = () => {
    return Logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof Logout>>
>;

export type LogoutMutationError = unknown;

export const useLogout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Logout>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options), queryClient);
};
export const VerifyPassword = (
  verifyPasswordReq?: VerifyPasswordReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<VerifyPasswordResp>(
    {
      url: `/intl/auth/verify-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyPasswordReq,
      signal,
    },
    options,
  );
};

export const getVerifyPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof VerifyPassword>>,
    TError,
    { data?: VerifyPasswordReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof VerifyPassword>>,
  TError,
  { data?: VerifyPasswordReq },
  TContext
> => {
  const mutationKey = ["verifyPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof VerifyPassword>>,
    { data?: VerifyPasswordReq }
  > = (props) => {
    const { data } = props ?? {};

    return VerifyPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof VerifyPassword>>
>;
export type VerifyPasswordMutationBody = VerifyPasswordReq | undefined;
export type VerifyPasswordMutationError = unknown;

export const useVerifyPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof VerifyPassword>>,
      TError,
      { data?: VerifyPasswordReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof VerifyPassword>>,
  TError,
  { data?: VerifyPasswordReq },
  TContext
> => {
  return useMutation(getVerifyPasswordMutationOptions(options), queryClient);
};
export const SetPassword = (
  setPasswordReq?: SetPasswordReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/auth/set-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setPasswordReq,
      signal,
    },
    options,
  );
};

export const getSetPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof SetPassword>>,
    TError,
    { data?: SetPasswordReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof SetPassword>>,
  TError,
  { data?: SetPasswordReq },
  TContext
> => {
  const mutationKey = ["setPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof SetPassword>>,
    { data?: SetPasswordReq }
  > = (props) => {
    const { data } = props ?? {};

    return SetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof SetPassword>>
>;
export type SetPasswordMutationBody = SetPasswordReq | undefined;
export type SetPasswordMutationError = unknown;

export const useSetPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof SetPassword>>,
      TError,
      { data?: SetPasswordReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof SetPassword>>,
  TError,
  { data?: SetPasswordReq },
  TContext
> => {
  return useMutation(getSetPasswordMutationOptions(options), queryClient);
};
